export default __webpack_public_path__ + "static/media/cover-with-bg-mobile.da4ec578.jpg";